import { BaseLookupModel, LatLng, PaginationFilterRequest } from "./core.model";

export interface CityDistrict {
    id: number;
    name: string;
    jsonGeometry: string;
    cityId: number;
    city: BaseLookupModel;
    hasAchievement: boolean;
}

export interface UpsertCityDistrict {
    id?: number;
    name?: string;
    jsonGeometry?: string;
    cityId?: number;
}

export interface InsertCityMultipleDistrict {
    cityId?: number;
    districts?: {name?: string; coordinates?: LatLng[]}[]
}

export class CityDistrictPaginationFilterRequest extends PaginationFilterRequest{  
    cityId?: number;
    countryId?: number;
}
